import React from 'react'
import VariantPickerWidget from './VariantPickerWidget'

const ProductVariantsPicker = (props) => {
	const {
		attributes,
		onChange,
		matchVariantFromSelection,
		selectedValues,
		setSelectedValues
	} = props

	const onChangeAttributes = (key, val) => {
		const newData = { ...selectedValues, [key]: val }
		setSelectedValues(newData)
		onChange(newData)
	}

	return (
		<div className='mb-10'>
			{Object.entries(attributes).map(([key, values], i) => (
				<VariantPickerWidget
					key={i}
					selected={selectedValues[key]}
					onChangeSelected={onChangeAttributes}
					selection={selectedValues}
					matchVariantFromSelection={matchVariantFromSelection}
					attributeKey={key}
					values={values}
				/>
			))}
		</div>
	)
}

export default React.memo(ProductVariantsPicker)
